module.exports = __webpack_public_path__ + "img/charity_web.d3b96870.png";